import { getWhitelabel } from 'services/whiteLabel'

/** True when Auth0 env + whitelabel client ID are present; avoids mounting Auth0Provider on offline / local LAN builds. */
export function isAuth0Configured(): boolean {
  const wl = getWhitelabel()
  const domain = String(import.meta.env.VITE_AUTH0_CLIENT_DOMAIN ?? '').trim()
  const clientRaw = wl.auth0ClientId ?? import.meta.env.VITE_AUTH0_CLIENT_ID
  const clientId = String(clientRaw ?? '').trim()
  return domain.length > 0 && clientId.length > 0
}

/**
 * auth0-spa-js only runs in a "secure context" (HTTPS, http://localhost, http://127.0.0.1, etc.).
 * Plain http://192.168.x.x fails — same check as `window.isSecureContext`.
 */
export function isAuth0SpaOriginAllowed(): boolean {
  if (typeof window === 'undefined') return true
  return window.isSecureContext
}

/** Mount Auth0 only when credentials exist and the browser will let the SDK run. */
export function shouldMountAuth0Provider(): boolean {
  return isAuth0Configured() && isAuth0SpaOriginAllowed()
}
